import firestore from "@/api/firestore";
import products from "@/api/products";
import firebase from "firebase";
import 'firebase/auth'
import {sleep, hasSession, localStorageLabel} from "@/utils/helpers";
import slugify from "slugify";

const state = () => ({
    profile: {},
    profileUpdates: {},
    user: {},
    active: false,
    isFetched: false
})

const mutations = {
    setRegion (state, region) {
        state.region = region
    },
    setUser (state, user) {
        state.user = {
            uid: user.uid,
            email: user.email
        }
    },
    setProfile(state, profile) {
        state.profile = profile
    },
    setFetched(state, val) {
        state.isFetched = val
    },
    unsetUser (state) {
        state.user = {}
    },
    setProfileUpdate (state, profile) {
        state.profileUpdates = {
            ...state.profileUpdates,
            ...profile
        }
    },
    resetProfileUpdates (state) {
        state.profileUpdates = {}
    },
    setActive (state, active) {
        state.active = active
    }
}

const getters = {
    detailsChanged:  (state) => {
        const updates = state.profileUpdates
        const fields = Object.keys(state.profileUpdates)
        return fields.some(key => updates[key] !== undefined)
    },
    isLoggedIn: () => {
        return hasSession()
    }
}

const actions = {
    async fetchUserProfile ({ state, commit }) {
        if (state.user) {
            const profile = await firestore.getUserProfile(state.user.uid)
            commit('setProfile', profile)
            if (profile.vendor) {
                const vendorData = await firestore.getVendorData(profile.vendor)
                commit('setActive', vendorData.active)
            }
            commit('setFetched', true)
        }
    },
    async doLogout ({ commit }) {
        await commit('unsetUser')
        localStorage.removeItem(localStorageLabel())
        await commit('setFetched', false)
    },

    async saveProfile ({ state, commit }) {
        if (state.user) {
            const profile = await firestore.saveUserProfile(state.user.uid, state.profileUpdates)
            if (state.profileUpdates.region !== undefined) {
                const regionTag = slugify(`region ${state.profileUpdates.region}`, {lower: true})
                await products.addTagToAllProducts(regionTag)
            }
            commit('resetProfileUpdates')
            commit('setProfile', profile)
        }
    },
    async fetchIdToken () {
        let attempts = 0;
        while (!firebase.auth().currentUser && attempts < 10) {
            await sleep(500);
            attempts++;
        }
        if (!firebase.auth().currentUser) {
            throw new Error("No authenticated user found");
        }
        return await firebase.auth().currentUser.getIdToken()
    }
}

export default {namespaced: true, state, mutations, actions, getters}
